import React from 'react'

import { createMarkup } from 'utils/react'

export default class NodeDescription extends React.Component {
    render() {
        return <div dangerouslySetInnerHTML={createMarkup(this.props.node.description)} />
    }
}
